<template>
  <div class="language-switcher">
    <slot :language-links="linksMapped">
      <p class="is-small heavy">
        {{ $texts('languageSwitchLabel') }}
      </p>
      <Dropdown :options="linksMapped" :model-value="language" />
    </slot>
  </div>
</template>

<script lang="ts" setup>
import type { Langcode } from '#nuxt-language-negotiation/config'
import type { RouteLocationRaw } from 'vue-router'

const language = useCurrentLanguage()
const links = useLanguageLinks()

const LABEL: Record<Langcode, string> = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Francais',
}

const linksMapped = computed<
  {
    value: string
    label: string
    href?: RouteLocationRaw
    active: boolean
  }[]
>(() =>
  links.value.map((v) => {
    return {
      value: v.code,
      label: LABEL[v.code as Langcode],
      href: v.to,
      active: language.value === v.code,
    }
  }),
)
</script>
